import { FormattedDateString } from "../../utilities/DateHelper"
import Services from '../../service/ApiServices'
import _ from "lodash"

export const GET_MULTI_LOCATION_TREE = "HIERARCHY/GET_MULTI_LOCATION_TREE"
export const GET_TREE_BY_LOCATION_ID = "GET_TREE_BY_LOCATION_ID"
export const SET_PARENTS_IN_HIERARCHY = "SET_PARENTS_IN_HIERARCHY"
export const SET_BUILDINGS = "SET_BUILDINGS"
export const SET_PARENT_TYPES = "SET_PARENT_TYPES"
export const SET_PARENTS = "SET_PARENTS"
export const SET_ROOMS = "SET_ROOMS"
export const SET_BEDS = "SET_BEDS"
export const SET_TYPE = "SET_TYPE"
export const ACTIVE_TREE = "ACTIVE_TREE"
export const CURRENT_LOCATION = "CURRENT_LOCATION"
export const LEVEL_TYPES = "LEVEL_TYPES"
export const SELECTED_TREENODE = "SELECTED_TREENODE"
export const HAS_LOCATION_CHANGED = "HAS_LOCATION_CHANGED"


export const GetMultipleLocationTreeWithFilter = async (filter)=>{  
    const response = await Services.Hierarchy.getMultipleLocationTreeWithFilter(filter);   
    return {type: GET_MULTI_LOCATION_TREE, tree: response.data.root}
}

export const GetTreeByLocationId = async (locationId, filter)=>{
    const response = _.isEmpty(filter)?await Services.Hierarchy.getLocationTreeById(locationId) :await Services.Hierarchy.getLocationTreeWithFilter(locationId, {...filter, date:FormattedDateString(filter.date)});   
    return {type: GET_TREE_BY_LOCATION_ID, tree: response.data}
}
export const SetLocationChangeDetail = (changeDetail)=>{
    return {type: HAS_LOCATION_CHANGED, changeDetail}

}

export const SetCurrentLocation = (location)=>{
    return {type: CURRENT_LOCATION, location}
}
export const SetParentsInHierarchy = (parentsInHierarchy)=>{
    return {type: SET_PARENTS_IN_HIERARCHY, parentsInHierarchy}
}

export const SetBuildings = (buildings)=>{
    return {type: SET_BUILDINGS, buildings}
}

export const SetParentTypes = (parentTypes)=>{
    return {type: SET_PARENT_TYPES, parentTypes}
}
export const SetParents = (parents)=>{
    return {type: SET_PARENTS, parents}
}
export const SetRooms = (rooms)=>{
    return {type: SET_ROOMS, rooms}
}
export const SetBeds = (beds)=>{
    return {type: SET_BEDS, beds}
}

export const SetType = (levelType)=>{
    return {type: SET_TYPE, levelType}
}

export const SetActiveTree = (tree)=>{
    return {type:ACTIVE_TREE, tree}
}

export const SetLevelTypes = (levelTypes)=>{
    return {type: LEVEL_TYPES, levelTypes}
}

export const SelectedTreeNode = (node)=>{
    return {type:SELECTED_TREENODE, node}

}